var watchlistPositionList = {
	caption: "Watchlist Position List",
	name: "Name",
	isin: "ISIN",
	lastPrice: "Last price",
	lastPriceDateTime: "Date/Time",
	perf: "Perf.",
	perfRel: "Perf. %",
	volume: "Volume",
	tradingVolume: "Trading vol.",
	exchange: "Market",
	actions: "Actions",
	noPositions: "No results found"
};
var en = {
	watchlistPositionList: watchlistPositionList
};

export { en as default, watchlistPositionList };
